/**
 * Created by Josef Jurca on 17.7.2017.
 */
import _ from 'lodash';

import {
    convertForGetBookmarks,
    convertFromRead
} from '../adapters/bookmark';

import {isValidResponse} from '../validators/assets';
import Bookmark from 'models/bookmark';

/**
 * Returns assets history.
 *
 * @param {Array} ids - Asset ids of which we want to get history.
 * @returns {Promise} Get asset promise.
 */
export function getBookmarks (ids) {
    const url = this._baseUrl + this._endPoints.bookmark;

    return this.read(
        {
            url: url,
            data: convertForGetBookmarks.call(this, ids)
        })
        .then(response => {

            if (!isValidResponse(response)) {
                return [];
            }
            
            return _.map(convertFromRead.call(this, response.result), (history) => {
                return new Bookmark(history);
            });
        });
}


// WEBPACK FOOTER //
// ./src/js/datasources/kaltura/services/bookmark.js